export enum UserBadgeType {
  DO_GOODER = 'do-gooder.svg',
  FOUNDATION_SHAREHOLDER = 'foundation-shareholder.svg',
}
